import React, { useState } from 'react';
import TaskForm from '../components/TaskForm';
import TaskCard from '../components/TaskCard';
import './TasksPage.css';

function TasksPage({ tasks, phases, onAddTask, onUpdateTask, onDeleteTask }) {
  const [showForm, setShowForm] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [filterPhase, setFilterPhase] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [sortBy, setSortBy] = useState('priority');

  const filteredTasks = tasks.filter(task => {
    const phaseMatch = filterPhase === 'all' || task.phase_id === parseInt(filterPhase);
    const statusMatch = filterStatus === 'all' || task.status === filterStatus;
    return phaseMatch && statusMatch;
  });

  const sortedTasks = [...filteredTasks].sort((a, b) => {
    switch (sortBy) {
      case 'priority':
        return a.priority - b.priority;
      case 'date':
        return new Date(a.estimated_start_date) - new Date(b.estimated_start_date);
      case 'cost':
        return (b.cost || 0) - (a.cost || 0);
      default:
        return 0;
    }
  });

  const handleSubmit = async (formData) => {
    try {
      if (editingTask) {
        await onUpdateTask(editingTask.id, formData);
        setEditingTask(null);
      } else {
        await onAddTask(formData);
      }
      setShowForm(false);
    } catch (err) {
      alert('Erreur: ' + err.message);
    }
  };

  const handleStatusChange = async (task) => {
    const newStatus = task.status === 'Terminé' ? 'A faire' : 'Terminé';
    try {
      await onUpdateTask(task.id, { status: newStatus });
    } catch (err) {
      alert('Erreur: ' + err.message);
    }
  };

  const groupedByPhase = {};
  sortedTasks.forEach(task => {
    const phaseName = task.phase_name || 'Sans phase';
    if (!groupedByPhase[phaseName]) {
      groupedByPhase[phaseName] = [];
    }
    groupedByPhase[phaseName].push(task);
  });

  return (
    <div className="tasks-page">
      <div className="tasks-header">
        <h2>✅ Gestion des Tâches</h2>
        <button className="btn btn-primary" onClick={() => {
          setEditingTask(null);
          setShowForm(!showForm);
        }}>
          {showForm ? '✕ Fermer' : '➕ Nouvelle Tâche'}
        </button>
      </div>

      {showForm && (
        <TaskForm
          phases={phases}
          onSubmit={handleSubmit}
          initialData={editingTask}
          onCancel={() => {
            setShowForm(false);
            setEditingTask(null);
          }}
        />
      )}

      {/* Filtres */}
      <div className="filters-bar">
        <div className="filter-group">
          <label>Phase:</label>
          <select value={filterPhase} onChange={e => setFilterPhase(e.target.value)}>
            <option value="all">Toutes</option>
            {phases.map(phase => (
              <option key={phase.id} value={phase.id}>
                {phase.nom}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Statut:</label>
          <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
            <option value="all">Tous</option>
            <option value="A faire">À faire</option>
            <option value="En cours">En cours</option>
            <option value="Terminé">Terminé</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Trier par:</label>
          <select value={sortBy} onChange={e => setSortBy(e.target.value)}>
            <option value="priority">Priorité</option>
            <option value="date">Date</option>
            <option value="cost">Coût</option>
          </select>
        </div>

        <div className="task-count">
          {sortedTasks.length} tâche(s)
        </div>
      </div>

      {/* Tâches groupées par phase */}
      <div className="tasks-container">
        {Object.entries(groupedByPhase).length === 0 ? (
          <div className="empty-state">
            <p>📭 Aucune tâche ne correspond aux filtres</p>
          </div>
        ) : (
          Object.entries(groupedByPhase).map(([phaseName, phaseTasks]) => (
            <div key={phaseName} className="phase-section">
              <h3 className="phase-title">{phaseName}</h3>
              <div className="tasks-grid">
                {phaseTasks.map(task => (
                  <TaskCard
                    key={task.id}
                    task={task}
                    onEdit={(task) => {
                      setEditingTask(task);
                      setShowForm(true);
                    }}
                    onDelete={onDeleteTask}
                    onStatusChange={handleStatusChange}
                  />
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default TasksPage;
